import { MessageSquare, Eye, Factory, Truck } from "lucide-react";

const STEPS = [
  {
    n: "01",
    icon: MessageSquare,
    title: "Design Consultation",
    desc: "Tell us about your group, your colours, any cultural elements you want included, and we'll talk through options together.",
  },
  {
    n: "02",
    icon: Eye,
    title: "Free Mockup",
    desc: "Our designers create a custom mockup of your polo — front, back, sleeve and embroidery placement. You see it before you commit.",
  },
  {
    n: "03",
    icon: Factory,
    title: "Production",
    desc: "Once you sign off the design, we produce your uniforms on premium polo blanks with full-colour print or embroidery.",
  },
  {
    n: "04",
    icon: Truck,
    title: "Delivery",
    desc: "We ship NZ-wide or you can collect from our Auckland studio. Standard turnaround is 2–3 weeks from approval.",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="how-it-works"
      data-testid="how-it-works-section"
      className="relative py-24 md:py-32"
    >
      <div className="absolute inset-0 tribal-pattern opacity-25 pointer-events-none" />
      <div className="relative max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <p className="text-xs uppercase tracking-[0.3em] text-gold font-semibold">
            Our Process
          </p>
          <h2 className="mt-3 font-display uppercase text-4xl md:text-6xl tracking-tight leading-[0.95]">
            How it <span className="text-teal-400">works</span>
          </h2>
          <p className="mt-4 text-zinc-400">
            Four simple steps from idea to your community wearing it with pride.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-0 relative">
          {STEPS.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={s.n}
                data-testid={`step-${s.n}`}
                className={`relative p-7 lg:p-8 bg-zinc-900 border border-zinc-800 ${
                  i < STEPS.length - 1 ? "lg:border-r-0" : ""
                } hover:bg-zinc-900/80 group`}
              >
                <div className="flex items-center justify-between mb-6">
                  <span className="font-display text-5xl md:text-6xl text-zinc-800 group-hover:text-teal-400/30 transition-colors">
                    {s.n}
                  </span>
                  <div className="w-11 h-11 bg-teal-400/10 border border-teal-400/30 grid place-items-center">
                    <Icon size={20} className="text-teal-400" />
                  </div>
                </div>
                <h3 className="font-display uppercase text-xl md:text-2xl tracking-tight">
                  {s.title}
                </h3>
                <p className="mt-3 text-sm text-zinc-400 leading-relaxed">{s.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
